/**
 * A troca de texto do "Baixar" da aba E-mail Atendimento, regra PURA (`admin.html:9678-9680`;
 * linha 227 do inventário): o modelo baixado do Storage sai com o nome da cliente e a assinatura
 * fixa da Lu no lugar dos dois marcadores.
 */

/**
 * A assinatura que entra no lugar de `[Sua assinatura e contatos]`, palavra por palavra do legado
 * (`admin.html:9680`), com a quebra de linha entre o nome e os contatos.
 */
export const ASSINATURA_DA_LU = 'Lu Barros\n(61) 99134-1792 | contato@studiolu.com.br';

/**
 * Preenche o modelo. As duas trocas ignoram maiúsculas e trocam todas as ocorrências, como o
 * `/.../gi` do legado; sem nome, o marcador vira texto vazio, como o `|| ''`.
 */
export function preencherModelo(texto: string, nomeDaCliente: string | null | undefined): string {
  return texto
    .replace(/\[nome da cliente\]/gi, nomeDaCliente || '')
    .replace(/\[Sua assinatura e contatos\]/gi, ASSINATURA_DA_LU);
}
